

















































































































































import { defineComponent, getCurrentInstance } from '@vue/composition-api';
import { FolderIcon, SettingIcon, ViewModuleIcon, DeleteIcon } from 'tdesign-icons-vue';

import { setResizableColumns } from '@/renderer/scripts/composition/tableResizeHandler';

import i18n, { i18n_t } from '@/locales/i18n';
import smh from '@/renderer/scripts/smh';
import ipc from '@/renderer/scripts/utils/ipc';
import { overCurrentTime } from '@/renderer/scripts/utils/dayjsUsage';
import tips from '@/renderer/scripts/utils/tips';

import listOperateHandler from '@/renderer/scripts/composition/listOperateHandler';
import launchFileTableHandler from '../composition/launchFileTableHandler';

export default defineComponent({
  name: 'LaunchFileTable',
  components: { FolderIcon, SettingIcon, ViewModuleIcon, DeleteIcon },
  setup(_, ctx) {
    const { columns, tableData, loading, pageData, sort, methods: listMethods } = launchFileTableHandler();
    const {
      operateShowMap,
      hoverIndex,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      isFourthButtonHover,
      isDropdownShow,
      methods: listOperateMethods,
    } = listOperateHandler({ ...tableData, selectedRowKeys: [], selectedList: [] });

    const resizeColumns = setResizableColumns(columns);

    const methods = {
      async onDeleteConfirm(row: { id: number }) {
        try {
          await smh.userAPI.deleteFileCollection({ collectId: row.id });
          tips.success(i18n_t('删除成功'));
          ipc.emit(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH);
        } catch (e) {
          tips.error(e as MsgError);
        }
      },
      launchCollection() {
        ctx.emit('launchCollection');
      },
      openSetting(row: { id: number }) {
        ctx.emit('openSetting', row.id);
      },
      viewDetails(row: { id: number }) {
        ctx.emit('viewDetails', row.id);
      },
      async operationFileOrDir(row: { path: string[]; spaceId: string; spaceOrgId: number }) {
        const { path, spaceId, spaceOrgId } = row;
        if (!path) return tips.error(i18n_t('文件夹被删除'));
        const options = {
          path: path.join('/'),
          spaceId,
          spaceOrgId,
        };
        const { data } = await smh.userAPI.getDirectoryOrFileInfo(options);
        ipc.emit(ipc.RENDERER_EVENTS_MAP.DRAWER_DYNAMIC_OPEN, {
          ...data,
          toObjectPath: data.path.join('/'),
          spaceId,
          orgId: spaceOrgId,
        });
      },
      taskIsInvalid(item: { path: string[]; status: number }) {
        return !item.path || !item.status;
      },
    };
    return {
      ...methods,
      loading,
      sort,
      pageData,
      resizeColumns,
      tableData,
      hoverIndex,
      operateShowMap,
      listOperateMethods,
      overCurrentTime,
      listMethods,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      isFourthButtonHover,
      isDropdownShow,
    };
  },
});
